export const BASE_ROLES = Object.freeze({
  ADMIN: 'Chat Admin',
  CHAT: 'Chat',
  VIDEO: 'Video',
  CALENDAR: 'Calendar',
  VIDEO_FREE: 'Free Video',
  VIDEO_TEAM: 'Team Video',
  VIDEO_ADMIN: 'Video Admin',
  REPORTING: 'Reporting',
  PLAYBOOKS: 'Playbooks',
})

export const CONVERSATION_ROLES = Object.freeze({
  ALL: 'Chat All',
  ONLY_MINE: 'Chat Only Mine',
  NO_PARTICIPANTS: 'Chat With No Participants',
})

export const ENTERPRISE_ROLES = [BASE_ROLES.REPORTING, BASE_ROLES.PLAYBOOKS]

export const MAX_USER_LAST_ACTIVE_TIME = '1+ year ago'
